/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViewConfigurationResponse {
    getFixupPrototypeFunction() { return ViewConfigurationResponse.fixupPrototype; }

    static newInstance(model: Partial<ViewConfigurationResponse>): ViewConfigurationResponse {
        let obj = Object.assign(new ViewConfigurationResponse(), model);
        ViewConfigurationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViewConfigurationResponse>): ViewConfigurationResponse {
        if (!model) return null;
        return ViewConfigurationResponse.newInstance(<ViewConfigurationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViewConfigurationResponse) {
        if (!obj) return;

        models.ViewConfigurationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViewConfigurationResponse): boolean {
        Object.setPrototypeOf(obj, ViewConfigurationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Message of View Configuration
     */
    message: string;

    /**
     * View Configuration Listing
     */
    data: any;

}
